import moment from 'moment-timezone';

let privateMomentInstance: typeof moment | undefined;

export function getMoment(): typeof moment {
    if (privateMomentInstance) {
        return privateMomentInstance;

    } else if (require) {
        // eslint-disable-next-line n/global-require, @typescript-eslint/no-require-imports
        privateMomentInstance = require('moment-timezone');
        return privateMomentInstance!;
    } else {
        throw new Error('moment has not been initialised.');
    }
}

export function setMoment(newMoment: typeof moment): void {
    privateMomentInstance = newMoment;
}
